import { PageHeader, Tabs } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '../components'
import ContractsForm from './components/ContractsForm'
import AbsenceTypesForm from './components/AbsenceTypesForm'
import { Text } from '@lmc/ui-kit/src/general'
import { showToast } from 'common/utils'
import { useAbsenceTypesList } from '../hooks/useAbsenceTypesList'
import { useAbsenceTypesUpdate } from '../hooks/useAbsenceTypesUpdate'
import SettingsPaywall from './components/SettingsPaywall'
import useHomeType from 'hooks/useHomeType'
import { useState } from 'react'
import NavigationModal from 'components/NavigationModal/NavigationModal'

const ContractsAndAbsenceSettingsScreen = () => {
  const { t } = useTranslation()
  const { absenceTypes, isAbsenceTypesLoading } = useAbsenceTypesList()
  const { updateAbsenceTypes } = useAbsenceTypesUpdate({
    onSuccess: () => {
      showToast({ title: t('ROTA_SETTINGS_UPDATED') })
    },
  })
  const { hasRota } = useHomeType()

  const [isContractsFormDirty, setContractsFormDirty] = useState(false)
  const [isAbsencesFormDirty, setAbsencesFormDirty] = useState(false)

  const canNavigate = !(isContractsFormDirty || isAbsencesFormDirty)

  return (
    <>
      <PageHeader
        title={hasRota ? t('CONTRACTS_AND_ABSENCE') : t('CONTRACT')}
        subtitle={t('CONTRACTS_AND_ABSENCE_INFO')}
        sticky
      />
      <PageWrapper>
        {hasRota ? (
          <Tabs
            tabBarStyle={tabBarStyle}
            items={[
              {
                key: '1',
                label: <Text>{t('CONTRACT_TYPES')}</Text>,
                children: (
                  <SettingsPaywall
                    startingText={t('CONTRACTS_AND_ABSENCES_INFO_IS')}
                  >
                    <ContractsForm
                      isDirty={isContractsFormDirty}
                      setIsDirty={setContractsFormDirty}
                    />
                  </SettingsPaywall>
                ),
              },
              {
                key: '2',
                label: <Text>{t('ABSENCES')}</Text>,
                children: (
                  <SettingsPaywall startingText={t('RECORDING_ABSENCES_IS')}>
                    <AbsenceTypesForm
                      absenceTypes={absenceTypes}
                      isAbsenceTypesLoading={isAbsenceTypesLoading}
                      updateAbsenceTypes={updateAbsenceTypes}
                      isDirty={isAbsencesFormDirty}
                      setIsDirty={setAbsencesFormDirty}
                    />
                  </SettingsPaywall>
                ),
              },
            ]}
          />
        ) : (
          <SettingsPaywall startingText={t('CONTRACTS_AND_ABSENCES_INFO_IS')}>
            <ContractsForm
              isDirty={isContractsFormDirty}
              setIsDirty={setContractsFormDirty}
            />
          </SettingsPaywall>
        )}
      </PageWrapper>
      <NavigationModal
        canNavigate={canNavigate}
        modalContentText={t('ROTA_SETTINGS_NAVIGATION_MODAL_CONTENT')}
      />
    </>
  )
}

export default ContractsAndAbsenceSettingsScreen

const tabBarStyle = { paddingLeft: 24 }
